import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import { getDefaultState } from '@/store/plugins/localStoragePlugin'

export default {
  namespaced: true,
  state: getDefaultState(
    'user.agency',
    {
      agentRequestUnread: {
        selfUnread: 0,
        agencyUnread: 0
      },
      agencies: [], // Admin uniquement
      agents: [],
      clients: [],
      sites: [],
      rondes: [],
      checkpoints: [],
      pricing: {
        agentsLimit: 0,
        accountLimit: 0,
        countAgents: {
          accounts: 0,
          agents: 0
        }
      },
      fetching: {}
    }
  ),
  actions,
  mutations,
  getters
}
